import { processTypeStageToPerformOptions } from "../../../shared/utils/static-values";
import "./actions.scss";
import { usePrompt } from "../../../shared/utils/use-prompt";
import { IColumn } from "../../components/data-table/data-table";
import EditableListPage from "../../components/editable-list-page/editable-list-page";

import { useState } from "react";

import ConfirmationPopup from "../../../shared/components/confirmation-popup/confirmation-popup";

const columns: IColumn[] = [
  {
    key: "name",
    displayName: "Name",
    dataType: {
      type: "text",
    },
  },
  {
    key: "to_perform",
    displayName: "To perform",
    dataType: {
      type: "enumeration",
      values: processTypeStageToPerformOptions,
    }
  }
];

const Actions = () => {
  const [isDirty, setIsDirty] = useState<boolean>(false);
  const { flag, setFlag, next } = usePrompt(isDirty);
  const [handleForceSave, setHandleForceSave] = useState<boolean>(false);

  return (
    <div className="actionsList">
      <EditableListPage
        title="Actions"
        defaultSortCol="name"
        columns={columns}
        dataUrl={{
          url: "actions",
          backend: "manager",
          transformType: "action"
        }}
        postUrl={{
          url: "actions",
          backend: "manager",
          transformType: "action"
        }}
        handleDataChange={(isDirty: boolean) => {
          setIsDirty(isDirty);
        }}
        forceSave={handleForceSave}
        setForceSave={setHandleForceSave}
      />
      {flag && <ConfirmationPopup show={flag} handleSaveClick={() => {
        setIsDirty(false);
        setHandleForceSave(true);
        next();
      }}
      handlePopupClosed={() => {
        setFlag(false);
      }}
      handleContinue={() => { next(); setFlag(false); }} />
      }
    </div>
  );
};

export default Actions;